import { Address } from "viem"

import { IS_MEZO_MAINNET } from "../network"

const abi = [
  {
    inputs: [],
    name: "optimisticMintingFeeDivisor",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const

const mainnetAddress = "0x9C070027cdC9dc8F82416B2e5314E11DFb4FE3CD"
const sepoliaAddress = "0xB5679dE944A79732A75CE556191DF11F489448d5"

const address: Address = IS_MEZO_MAINNET ? mainnetAddress : sepoliaAddress

export default {
  abi,
  address,
}
